module.exports = __webpack_public_path__ + "img/correcao-estatica-tomografia-1.5795a5b7.png";